import React, { useEffect, useRef, useState } from "react";
import { Form, Input, InputNumber, Modal, Select, Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { save } from "../../../../features/save/saveSlice";
import { fetchBankBranch } from "../../../../features/dropdown/dropdownSlice";
import { fetchPersonnelFolders } from "../../../../features/folder/folderSlice";
import { dutyData, userTitleData, userTypeData, YesNoData } from "../../../../data";
import PhoneInput from "react-phone-input-2";

const { TextArea } = Input;

const AddUsersModal = ({ open, handleCancel, handleFetchData, prodd }) => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { bankBranch, loading } = useSelector((state) => state.dropdown);
  const { saving } = useSelector((state) => state.save);

  const { personnelFolders } = useSelector((state) => state.folder);

  const [formData, setFormData] = useState(prodd);

  const onChange = async (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const onChangeOther = (value, fieldName) => {
    setFormData((prev) => ({
      ...prev,
      [fieldName]: value,
    }));
  };

  const handleNumberChange = (e) => {
    setFormData((prevData) => ({
      ...prevData,
      usrMobileNumber: String(e),
    }));
  };

  async function handleSelectChange(value, formName) {
    await setFormData((prevData) => ({
      ...prevData,
      [formName]: value,
    }));
  }

  const onFinish = async (data) => {
    if (!formData?.usrPersId) {
      toast.error("Please select personnel");
      return;
    }

    const res = await dispatch(
      save({
        usrId: prodd?.usrId ? prodd?.usrId : null,
        usrPersId: formData?.usrPersId,
        usrFirstName: formData?.usrFirstName,
        usrLastName: formData?.usrLastName,
        usrUsername: formData?.usrUsername,
        usrMobileNumber: formData?.usrMobileNumber,
        usrEmail: formData?.usrEmail,
        usrEnabled: formData?.usrEnabled,
        usrOnduty: formData?.usrOnduty,
        usrTitle:formData?.usrTitle,
        usrType:formData?.usrType,
        usrEncryptedPassword: formData?.usrEncryptedPassword,

        url: "usr/saveUser.action",
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await handleFetchData();
      await setFormData({});
      await handleCancel();
      await form.resetFields();
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  async function fetchPersonnelData(page, size) {
    dispatch(fetchPersonnelFolders());
  }
  async function fetchBankBranchData(page, size) {
    dispatch(fetchBankBranch());
  }

  useEffect(() => {
    setFormData(prodd);
  }, [prodd]);

  return (
    <>
      <Modal
        className="modal-btn mod-height mod-footer"
        title={prodd ? `Edit ${prodd?.usrUsername}` : "Add user details"}
        open={open}
        onOk={onFinish}
        onCancel={handleCancel}
        width={850}
      >
        <Form
          layout="vertical"
          ref={formRef}
          name="control-ref"
          onFinish={onFinish}
          className=" "
          style={{
            maxWidth: "100%",
          }}
          form={form}
        >
          <div className="grid grid-cols-2 gap-x-5">
            <Form.Item
              className=""
              label={<span>Personnel</span>}
              rules={[
                {
                  required: true,
                  message: "Please select personnel",
                },
              ]}
            >
              <Select
                name="usrPersId"
                className=""
                allowClear
                style={{
                  width: "100%",
                }}
                options={
                  personnelFolders?.length > 0 &&
                  personnelFolders?.map((item) => ({
                    value: item?.ppId,
                    label:
                      item?.ppPfno +
                      " - " +
                      item?.ppFullname +
                      " - " +
                      item?.coDeptname +
                      " - " +
                      item?.coSectionname,
                  }))
                }
                onChange={(value) => {
                  handleSelectChange(value, "usrPersId");
                }}
                value={formData?.usrPersId}
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label?.toLocaleLowerCase() ?? "").includes(
                    input?.toLocaleLowerCase()
                  )
                }
                onDropdownVisibleChange={() => {
                  fetchPersonnelData();
                }}
                dropdownRender={(menu) => (
                  <>
                    {loading && (
                      <div
                        style={{
                          padding: "8px",
                          textAlign: "center",
                        }}
                      >
                        <Spin className="sms-spin" />
                      </div>
                    )}
                    {menu}
                  </>
                )}
              />
            </Form.Item>

            <Form.Item
              label="First Name"
              rules={[
                {
                  required: true,
                  message: "Enter first name",
                },
              ]}
            >
              <Input
                name="usrFirstName"
                value={formData?.usrFirstName}
                onChange={onChange}
                className="input"
              />
            </Form.Item>

            <Form.Item
              label="Last Name"
              rules={[
                {
                  required: true,
                  message: "Enter Last name",
                },
              ]}
            >
              <Input
                name="usrLastName"
                value={formData?.usrLastName}
                onChange={onChange}
                className="input"
              />
            </Form.Item>

            <Form.Item
              label="User Name"
              rules={[
                {
                  required: true,
                  message: "Enter User name",
                },
              ]}
            >
              <Input
                name="usrUsername"
                value={formData?.usrUsername}
                onChange={onChange}
                className="input"
              />
            </Form.Item>

            <Form.Item
              label={<span>Phone No</span>}
              rules={[
                {
                  required: true,
                  message: "Enter phone number",
                },
              ]}
            >
              <PhoneInput
                required
                name="usrMobileNumber"
                onChange={handleNumberChange}
                value={formData?.usrMobileNumber}
                country="ke"
                onlyCountries={["ke"]}
                countryCodeEditable={false}
                className="input rounded-[6px] border !border-[#cacaca] !h-[42px]"
              />
            </Form.Item>
            <Form.Item
              label={
                <span>
                  Enter Email <span className="text-[#FF0000]">*</span>
                </span>
              }
              rules={[
                {
                  required: true,
                  message: "Add email address",
                },
                {
                  type: "email",
                  message: "Enter a valid email",
                },
              ]}
            >
              <Input
                required
                name="usrEmail"
                onChange={onChange}
                value={formData?.usrEmail}
                placeholder="Enter email"
                className="input"
              />
            </Form.Item>

            <Form.Item
              className=""
              label={<span>Enabled</span>}
              rules={[
                {
                  required: true,
                  message: "Please select enabled",
                },
              ]}
            >
              <Select
                name="usrEnabled"
                className=""
                allowClear
                style={{
                  width: "100%",
                }}
                options={
                  YesNoData?.length > 0 &&
                  YesNoData?.map((item) => ({
                    value: item?.value,
                    label: item?.label,
                  }))
                }
                onChange={(value) => {
                  handleSelectChange(value, "usrEnabled");
                }}
                value={formData?.usrEnabled}
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label?.toLocaleLowerCase() ?? "").includes(
                    input?.toLocaleLowerCase()
                  )
                }
                onDropdownVisibleChange={() => {}}
                dropdownRender={(menu) => (
                  <>
                    {loading && (
                      <div
                        style={{
                          padding: "8px",
                          textAlign: "center",
                        }}
                      >
                        <Spin className="sms-spin" />
                      </div>
                    )}
                    {menu}
                  </>
                )}
              />
            </Form.Item>

            <Form.Item
              className=""
              label={<span>On Duty</span>}
              rules={[
                {
                  required: true,
                  message: "Please select on duty",
                },
              ]}
            >
              <Select
                name="usrOnduty"
                className=""
                allowClear
                style={{
                  width: "100%",
                }}
                options={
                  dutyData?.length > 0 &&
                  dutyData?.map((item) => ({
                    value: item?.value,
                    label: item?.label,
                  }))
                }
                onChange={(value) => {
                  handleSelectChange(value, "usrOnduty");
                }}
                value={formData?.usrOnduty}
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label?.toLocaleLowerCase() ?? "").includes(
                    input?.toLocaleLowerCase()
                  )
                }
                onDropdownVisibleChange={() => {}}
                dropdownRender={(menu) => (
                  <>
                    {loading && (
                      <div
                        style={{
                          padding: "8px",
                          textAlign: "center",
                        }}
                      >
                        <Spin className="sms-spin" />
                      </div>
                    )}
                    {menu}
                  </>
                )}
              />
            </Form.Item>

            <Form.Item
              className=""
              label={<span>User Tile</span>}
              rules={[
                {
                  required: true,
                  message: "Please select user tile",
                },
              ]}
            >
              <Select
                name="usrTitle" 
                className="" 
                allowClear
                style={{
                  width: "100%",
                }}
                options={
                  userTitleData?.length > 0 &&
                  userTitleData?.map((item) => ({
                    value: item?.value,
                    label: item?.label,
                  }))
                }
                onChange={(value) => {
                  handleSelectChange(value, "usrTitle");
                }}
                value={formData?.usrTitle}
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label?.toLocaleLowerCase() ?? "").includes(
                    input?.toLocaleLowerCase()
                  )
                }
                onDropdownVisibleChange={() => {}}
                dropdownRender={(menu) => (
                  <>
                    {loading && (
                      <div
                        style={{
                          padding: "8px",
                          textAlign: "center",
                        }}
                      >
                        <Spin className="sms-spin" />
                      </div>
                    )}
                    {menu}
                  </>
                )}
              />
            </Form.Item>

            <Form.Item
              className=""
              label={<span>User Type</span>}
              rules={[
                {
                  required: true,
                  message: "Please select user type",
                },
              ]}
            >
              <Select
                name="usrType"
                className=""
                allowClear
                style={{
                  width: "100%",
                }}
                options={
                  userTypeData?.length > 0 &&
                  userTypeData?.map((item) => ({
                    value: item?.value,
                    label: item?.label,
                  }))
                }
                onChange={(value) => {
                  handleSelectChange(value, "usrType");
                }}
                value={formData?.usrType}
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label?.toLocaleLowerCase() ?? "").includes(
                    input?.toLocaleLowerCase()
                  )
                }
                onDropdownVisibleChange={() => {}}
                dropdownRender={(menu) => (
                  <>
                    {loading && (
                      <div
                        style={{
                          padding: "8px",
                          textAlign: "center",
                        }}
                      >
                        <Spin className="sms-spin" />
                      </div>
                    )}
                    {menu}
                  </>
                )}
              />
            </Form.Item>

            <Form.Item
              label="Password"
              rules={[
                {
                  required: true,
                  message: "Enter passowrd",
                },
              ]}
            >
                 {/* <Input.Password  name="usrEncryptedPassword" className="input-login"  value={formData?.usrEncryptedPassword}
                onChange={onChange} type="password" /> */}
              <Input
                name="usrEncryptedPassword"
                value={formData?.usrEncryptedPassword}
                onChange={onChange}
                className="input"
              />
            </Form.Item>
          </div>

          <div className="lg:flex-row flex-col justify-between mt-[56px] mb-[48px]">
            <div className="justify-start"></div>
            <div className="justify-end flex items-center gap-x-2">
              <div className="w-[200px]">
                <button
                  key="back"
                  type="button"
                  onClick={handleCancel}
                  className="cstm-btn !bg-white !text-lightBlack !border !border-lightBlack"
                >
                  Cancel
                </button>
              </div>

              <div className="w-[200px]">
                <button
                  key="submit"
                  type="submit"
                  className="cstm-btn"
                  disabled={saving}
                >
                  {saving ? <Spin /> : "Create"}
                </button>
              </div>
            </div>
          </div>
        </Form>
      </Modal>
    </>
  );
};
export default AddUsersModal;
